import React, {} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_HIDDEN_BUTTONS} from "../../../../../constants";
import NavWaterfallSection from "./toolWaterfall/NavWaterfallSection";
import workspaceControllers from "../../../../canvas/store/workspaceControllers";

const SqftNavWaterfall = (props) => {
  const {waterfallSectionsData, menuOpened} = props;

  const expanded = menuOpened === SIDEBAR_HIDDEN_BUTTONS.toolWaterfall && waterfallSectionsData.length > 0;

  return (
    <div className={"layouts side" + (expanded ? " expanded" : "")} >
      <div className="mitered-sections">
        {
          waterfallSectionsData.map((waterfallSectionData, index) => {
            const waterfallSection = workspaceControllers.waterfall.getResourceById(waterfallSectionData.id);
            if (waterfallSection) {
              return <NavWaterfallSection
                waterfallSectionData={waterfallSectionData} //redux data
                //waterfallSection={waterfallSection} // workspace.waterfall data
                index={index}
                key={index}/>
            }
          })
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    activeButton: store.sqftMenuState.activeButton,
    menuOpened: store.sqftMenuState.menuOpened,
    waterfallSectionsData: store.sqftResourceState.waterfallSectionsData
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavWaterfall);
